import { render, staticRenderFns } from "./OnboardingTypeform.vue?vue&type=template&id=5705a877&scoped=true&"
import script from "./OnboardingTypeform.vue?vue&type=script&lang=js&"
export * from "./OnboardingTypeform.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTypeform.vue?vue&type=style&index=0&id=5705a877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705a877",
  null
  
)

export default component.exports